import { Transition } from "@headlessui/react";
import { FiChevronDown, FiX } from "react-icons/fi";
import { MdWarningAmber } from "react-icons/md";

type MissingAccountsAlertProps = {
  consumers: any[];
  month: string;
  year: string;
  visible: boolean;
  dismissed: boolean;
  expanded: boolean;
  onCreateAccount: (consumerId: number | string) => void;
  onDismiss: () => void;
  onExpand: () => void;
  onCollapse: () => void;
};

const MissingAccountsAlert = ({
  consumers,
  month,
  year,
  visible,
  dismissed,
  expanded,
  onCreateAccount,
  onDismiss,
  onExpand,
  onCollapse,
}: MissingAccountsAlertProps) => (
  <Transition
    show={visible && consumers.length > 0 && !dismissed}
    enter="transition duration-300 ease-out"
    enterFrom="translate-y-[130%] opacity-0"
    enterTo="translate-y-0 opacity-100"
    leave="transition duration-200 ease-in"
    leaveFrom="translate-y-0 opacity-100"
    leaveTo="translate-y-[130%] opacity-0"
    className="fixed bottom-8 right-8 z-40 w-[min(420px,calc(100vw-4rem))]"
  >
    <div className="overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-slate-200">
      <div className="flex items-center gap-3 px-5 py-4">
        <MdWarningAmber className="shrink-0 text-amber-500" size={22} />
        <button
          type="button"
          className="flex flex-1 items-center justify-between gap-3 text-left text-slate-800"
          onClick={expanded ? onCollapse : onExpand}
          aria-expanded={expanded}
        >
          <span>
            <span className="block text-sm font-bold">Contas não criadas</span>
            <span className="mt-0.5 block text-xs text-slate-500">
              Clientes afetados em {month} de {year}
            </span>
          </span>
          <FiChevronDown
            className={`shrink-0 transition-transform duration-300 ${!expanded ? "rotate-180" : ""}`}
            size={20}
          />
        </button>
        <button
          type="button"
          className="rounded-full p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
          onClick={onDismiss}
          aria-label="Fechar aviso de contas não criadas"
        >
          <FiX size={18} />
        </button>
      </div>
      <Transition
        show={expanded}
        enter="transition-all duration-300 ease-out"
        enterFrom="max-h-0 opacity-0"
        enterTo="max-h-80 opacity-100"
        leave="transition-all duration-200 ease-in"
        leaveFrom="max-h-80 opacity-100"
        leaveTo="max-h-0 opacity-0"
        className="overflow-hidden"
      >
        <div className="border-t border-slate-100 bg-slate-50 p-4">
          <div className="max-h-64 space-y-2 overflow-y-auto pr-1">
            {consumers.map((consumer: any) => (
              <div
                key={consumer.consumer_id}
                className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2.5"
              >
                <span className="min-w-0 break-words text-sm font-semibold text-slate-800">
                  {consumer.consumer_name}
                </span>
                <button
                  type="button"
                  className="shrink-0 rounded-full bg-slate-900 px-3 py-1.5 text-xs font-bold text-white transition-colors hover:bg-slate-700"
                  onClick={() => onCreateAccount(consumer.consumer_id)}
                >
                  Criar conta
                </button>
              </div>
            ))}
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
);

export default MissingAccountsAlert;
